import React from "react";
import PropTypes from "prop-types";

const FormHeader = ({ name, icon, id }) => {
  return (
    <div className="row align-items-center my-2 underline">
      <div className="col mt-2">
        <h2 className="mt-2">
          <i className={icon}></i>{" "}
          {id === "new" ? `New ${name}` : `Edit ${name} Details`}
        </h2>
      </div>
    </div>
  );
};

// Typechecking
FormHeader.propTypes = {
  name: PropTypes.string.isRequired,
  icon: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
};

export default FormHeader;
